import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-physics.svg
 */
const IconTypePhysics: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    className={className}
    {...props}
  >
    <path d="M23.992 19.539a3.058 3.058 0 0 0-5.269-1.91l-1.961-1.031c.27-.625.418-1.313.418-2.035a5.15 5.15 0 0 0-.336-1.837.43.43 0 0 0-.496-.273.419.419 0 0 0-.29.555 4.345 4.345 0 0 1-.038 3.199l-1.188-.625a.419.419 0 0 0-.562.176.414.414 0 0 0 .175.562l1.184.625A4.345 4.345 0 0 1 12 18.907a4.345 4.345 0 0 1-3.629-1.962l1.184-.625a.417.417 0 1 0-.391-.738l-1.183.625a4.346 4.346 0 0 1 7.293-4.5.418.418 0 0 0 .625 0 .424.424 0 0 0-.004-.562 5.193 5.193 0 0 0-3.477-1.746V7.293a3.067 3.067 0 0 0 2.641-3.172 3.072 3.072 0 0 0-2.91-2.922 3.067 3.067 0 0 0-3.211 3.059 3.067 3.067 0 0 0 2.644 3.035v2.106a5.19 5.19 0 0 0-4.761 5.164c0 .722.148 1.41.418 2.035l-1.962 1.031a3.054 3.054 0 0 0-2.379-.946 3.072 3.072 0 0 0-2.894 2.911 3.064 3.064 0 0 0 4.23 2.976c.2-.082.32-.3.258-.507a.414.414 0 0 0-.563-.27 2.23 2.23 0 0 1-3.081-1.828 2.227 2.227 0 0 1 2.215-2.453 2.23 2.23 0 0 1 1.953 3.296.429.429 0 0 0 .144.567.415.415 0 0 0 .582-.152c.25-.453.383-.965.383-1.481 0-.515-.129-1-.356-1.425l1.86-.981A5.175 5.175 0 0 0 12 19.738a5.175 5.175 0 0 0 4.371-2.402l1.859.981a3.014 3.014 0 0 0-.347 1.628 3.071 3.071 0 0 0 2.859 2.852 3.065 3.065 0 0 0 3.25-3.258ZM9.774 4.258c0-1.227 1-2.227 2.226-2.227s2.226 1 2.226 2.227c0 1.231-1 2.231-2.226 2.231s-2.226-1-2.226-2.231Zm11.164 17.711a2.23 2.23 0 0 1-2.227-2.227c0-1.23 1-2.23 2.227-2.23 1.226 0 2.226 1 2.226 2.23 0 1.227-1 2.227-2.226 2.227Zm0 0" />
  </svg>
);

export default IconTypePhysics;
